import "./statistics.css";
import Layout from "../../layout";
import Table from "antd/lib/table";
import Select from "antd/lib/select";
import financeData from "../../data/finance_data";
import useTransactions from "../../hooks/use_transactions";
import { useEffect } from "react";
import formatHelper from "../../helpers/format_helper";
import { CurrenciesEnum, TransactionsEnum } from "../../utils/enums";
import moment from "moment";
import Pagination from "antd/lib/pagination";
import DatePicker from "antd/lib/date-picker";
import { useSelector } from "react-redux";
import Skeleton from "../../components/skeleton";
import { dateHelper } from "../../helpers/date_helper";
import { formatAmount } from "../../helpers/format_amount";
import useStatistics from "../../hooks/use_statistics";

const { RangePicker } = DatePicker;

const Statistics = () => {
  const { getStatistics, statisticsData, filters, setFilters, loadings } =
    useStatistics();

  const userProfile = useSelector((state) => state.app.userProfile);

  useEffect(() => {
    if (userProfile && filters.date) {
      if (!loadings.getStatistics) {
        getStatistics(filters);
      }
    }
  }, [userProfile, filters]);

  return (
    <Layout>
      <div className="finance">
        <h3>Statistics</h3>
        <div className="statistics-card">
          <div className="statistics-header">
            <div>
              <h4>Statistics Overview</h4>
              <p>Please select a date range for statistics</p>
            </div>

            <RangePicker
              className="statistics-datepicker"
              popupClassName="statistics-range-popup"
              value={filters.date}
              onChange={(value) => {
                console.log(value);
                setFilters({ ...filters, date: value });
                getStatistics({
                  date: value,
                });
              }}
              disabledDate={(current) => {
                return current && current > moment().endOf("day");
              }}
              size="small"
              allowClear={false}
            />
          </div>
        </div>

        {loadings.getStatistics ? (
          <div className="result">
            {Array(4)
              .fill()
              .map((item, index) => (
                <Skeleton key={index} style={{}} />
              ))}
          </div>
        ) : statisticsData?.length > 0 ? (
          <div className="result">
            {/* totalEarnings - totalRefunds */}
            <div>
              <div>
                <div>
                  <h4>Net income</h4>
                </div>
                <div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 3)
                        ?.totalEarnings -
                        statisticsData.find((o) => o.currency == 3)
                          ?.totalRefunds,
                    )}{" "}
                    CAD
                  </div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 2)
                        ?.totalEarnings -
                        statisticsData?.find((o) => o.currency == 2)
                          ?.totalRefunds,
                    )}{" "}
                    IRR
                  </div>
                </div>
              </div>
            </div>
            {/* totalEarnings */}
            <div>
              <div>
                <div>
                  <h4>Total Income</h4>
                </div>
                <div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 3)
                        ?.totalEarnings,
                    )}{" "}
                    CAD
                  </div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 2)
                        ?.totalEarnings,
                    )}{" "}
                    IRR
                  </div>
                </div>
              </div>
            </div>
            {/* totalRefunds */}
            <div>
              <div>
                <div>
                  <h4>Total Refunds</h4>
                </div>
                <div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 3)
                        ?.totalRefunds,
                    )}{" "}
                    CAD
                  </div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 2)
                        ?.totalRefunds,
                    )}{" "}
                    IRR
                  </div>
                </div>
              </div>
            </div>
            {/* totalDiscounts */}
            <div>
              <div>
                <div>
                  <h4>Total Discounts Used</h4>
                </div>
                <div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 3)
                        ?.totalDiscounts,
                    )}{" "}
                    CAD
                  </div>
                  <div>
                    {formatAmount(
                      statisticsData?.find((o) => o.currency == 2)
                        ?.totalDiscounts,
                    )}{" "}
                    IRR
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </Layout>
  );
};

export default Statistics;
